// with Key value pair
export const colorOptions = {
    "normal": "#DDCBD0",
    "fighting": "#fcc1b0",
    "flying": "#B2D2E8",
    "poison": "#CFB7ED",
    "ground": "#F4D1A6",
    "rock": "#C5AEA8",
    "bug": "#C1E0C8",
    "ghost": "#D7C2D7",
    "steel": "#C2D4CE",
    "fire": "#EDC2C4",
    "water": "#CBD5ED",
    "grass": "#C0D4C8",
    "electric": "#E2E2A0",
    "psychic": "#DDC0CF",
    "ice": "#C7D7DF",
    "dragon": "#CADCDF",
    "dark": "#C6C5E3",
    "fairy": "#E4C0Cf",
    "unknown": "#C0DFDD",
    "shadow": "#CACACA"
}


// with array format
// export const colorOptions = [
//     { value: "normal", color: "#DDCBD0" },
//     { value: "fighting", color: "#fcc1b0" },
//     { value: "flying", color: "#B2D2E8" },
//     { value: "poison", color: "#CFB7ED" },
//     { value: "ground", color: "#F4D1A6" },
//     { value: "rock", color: "#C5AEA8" },
//     { value: "bug", color: "#C1E0C8" },
//     { value: "ghost", color: "#D7C2D7" },
//     { value: "steel", color: "#C2D4CE" },
//     { value: "fire", color: "#EDC2C4" },
//     { value: "water", color: "#CBD5ED" },
//     { value: "grass", color: "#C0D4C8" },
//     { value: "electric", color: "#E2E2A0" },
//     { value: "psychic", color: "#DDC0CF" },
//     { value: "ice", color: "#C7D7DF" },
//     { value: "dragon", color: "#CADCDF" },
//     { value: "dark", color: "#C6C5E3" },
//     { value: "fairy", color: "#E4C0Cf" },
//     { value: "unknown", color: "#C0DFDD" },
//     { value: "shadow", color: "#CACACA" }
// ]